export default "__VITE_ASSET__Cjkb2JlU__"